import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreCommonModule } from '@core/common.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { CountyService } from '@core/services/county.service';
import { CarouselModule } from 'primeng/carousel';
import { PaymentsModule } from './payment-page/payments.module';
import { MatStepperModule } from "@angular/material/stepper";
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { ForgotUsernameComponent } from './landing-page/components/forgot-username/forgot-username.component';
import { AdRedirectingPageComponent } from './ad-redirecting-page/ad-redirecting-page.component';
import { SubjectEditPageComponent } from './subject-edit-page/subject-edit-page.component';
import { SharedModule } from 'app/shared/shared.module';
import { RegisterPopupComponent } from './landing-page/components/register-popup/register-popup.component';
import { RequestExamsModule } from './request-exams/request-exams.module';
import { MawinguRedirectComponent } from './mawingu-redirect/mawingu-redirect.component';
import { RegistrationHelpPageComponent } from './registration-help-page/registration-help-page.component';
import { ExternalRedirectComponent } from './external-redirect/external-redirect.component';
import { OtpInputComponent } from './landing-page/components/forgot-password/otp-input/otp-input';
import { TeacherForgotUsernameComponent } from './landing-page/components/forgot-username/teacher-forgot-username/teacher-forgot-username';
import { StudentResetPasswordComponent } from './landing-page/components/student-reset-password/student-reset-password';
import { LoginFormComponent } from './landing-page/components/login-form/login-form';
import { ForgotPasswordComponent } from './landing-page/components/forgot-password/forgot-password';
import { RegisterFormComponent } from './landing-page/components/register-form/register-form';

@NgModule({
    declarations: [
        AdRedirectingPageComponent,
        SubjectEditPageComponent,
        MawinguRedirectComponent,
        RegistrationHelpPageComponent,
        ExternalRedirectComponent,
    ],
    imports: [
        CoreCommonModule,
        ContentHeaderModule,
        NgbModule,
        NgSelectModule,
        FormsModule,
        MiscellaneousModule,
        RequestExamsModule,
        CarouselModule,
        PaymentsModule,
        MatStepperModule,
        SharedModule,
        OtpInputComponent,
        ForgotPasswordComponent,
        LoginFormComponent,
        TeacherForgotUsernameComponent,
        StudentResetPasswordComponent,
        ForgotUsernameComponent,
        TermsAndConditionsComponent,
        RegisterFormComponent,
        RegisterPopupComponent,
        LandingPageComponent, 
    ],
    providers: [
        CountyService
    ],
    exports: [
        TermsAndConditionsComponent,
    ]
})
export class PagesModule {
}